module.exports = __webpack_public_path__ + "img/418122.cf0f9c0c.png";